// extracted by mini-css-extract-plugin
export default {"Col":"Col_Col__yfrvg"};